import { FC } from 'react';
import { useAuthContext } from '@/context/AuthContext.tsx';
import { Navigate, Outlet } from 'react-router-dom';
import Routes from '@/router/Routes.ts';
import Middleware from '@/router/middleware/index.tsx';

const NotLoggedIn: FC = () => {
  const { isLoading, session } = useAuthContext();

  return <Middleware isLoading={isLoading}>{!session ? <Outlet /> : <Navigate to={Routes.HOME} />}</Middleware>;
};

export default NotLoggedIn;
